/* eslint-disable */
import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import admins from '@/store/modules/admins'
import candidates from '@/store/modules/candidates'
import carPark from '@/store/modules/carPark'
import carsConditions from '@/store/modules/carsConditions'
import carsLoad from '@/store/modules/carsLoad'
import configurator from '@/store/modules/configurator'
import consolidatedReport from '@/store/modules/consolidatedReport'
import contracts from '@/store/modules/contracts'
import dashboard from '@/store/modules/dashboard'
import debtorsByBalances from '@/store/modules/debtorsByBalances'
import dialogs from '@/store/modules/dialogs'
import IncomeHistory from '@/store/modules/DriversIncome/IncomeHistory'
import SingleTenantDetails from '@/store/modules/DriversIncome/SingleTenantDetails'
import driversStatistic from '@/store/modules/driversStatistic'
import fines from '@/store/modules/fines'
import investors from '@/store/modules/investors'
import maintenances from '@/store/modules/maintenances'
import OpenTransactions from '@/store/modules/OpenTransactions'
import parkStatistic from '@/store/modules/parkStatistic'
import parts from '@/store/modules/parts'
import regionPark from '@/store/modules/regionPark'
import report from '@/store/modules/report'
import roles from '@/store/modules/roles'
import schedule from '@/store/modules/schedule/index'
import settings from '@/store/modules/settings'
import { externalApisCredsSettings } from '@/store/modules/settings/externalApisCredsSettings'
import featuresVisibilitySettings from '@/store/modules/settings/featuresVisibilitySettings'
import stock from '@/store/modules/stock'
import techInspection from '@/store/modules/techInspection'
import templates from '@/store/modules/templates'
import tenantsIncome from '@/store/modules/tenantsIncome'
import tenantsInfo from '@/store/modules/tenantsInfo'
import user from '@/store/modules/user'
import worker from '@/store/modules/worker'
import { createStore, Module } from 'vuex-smart-module'
import { globalSettings } from '@/core/stores/Settings.store'
import { userStore } from '@/core/stores/User.store'

export interface IRootState {
}

Vue.use(Vuex)

const rootModule = new Module({
  modules: {
    externalApisCredsSettings,
    globalSettings,
    userStore
  }
})

const userEmailDataState = createPersistedState({
  paths: ['user.userEmailData', 'consolidatedReport.tableView', 'consolidatedReport.isShowHideColumns', 'schedule.ignoringDriverWorking']
})

const nativeRoot: Store<IRootState> = createStore(
  rootModule,
  {
    plugins: [userEmailDataState],
    modules: {
      user,
      tenantsIncome,
      schedule,
      driversStatistic,
      parkStatistic,
      tenantsInfo,
      carPark,
      report,
      techInspection,
      stock,
      admins,
      roles,
      carsLoad,
      carsConditions,
      maintenances,
      OpenTransactions,
      consolidatedReport,
      dialogs,
      regionPark,
      contracts,
      investors,
      parts,
      fines,
      configurator,
      templates,
      debtorsByBalances,
      worker,
      featuresVisibilitySettings,
      dashboard,
      SingleTenantDetails,
      // @ts-ignore
      settings,
      // @ts-ignore
      IncomeHistory,
      candidates
    }
  }
)

export default nativeRoot
